import * as React from 'react'

const SvgInternationalIcon = (props) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.02393 11.2264L4.0865 8.1638M11.3948 0.855469C13.8681 3.32879 13.8681 7.33883 11.3948 9.81215C8.9215 12.2855 4.91146 12.2855 2.43814 9.81215M10.5831 13.6671H3.91648M7.24982 13.6671V11.6671M10.9165 5.33381C10.9165 7.54295 9.12562 9.33381 6.91648 9.33381C4.70734 9.33381 2.91648 7.54295 2.91648 5.33381C2.91648 3.12467 4.70734 1.33381 6.91648 1.33381C9.12562 1.33381 10.9165 3.12467 10.9165 5.33381Z"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgInternationalIcon
